import React, { Component } from 'react';
import { Grid, Row, PageHeader } from 'react-bootstrap';
import {firestoredb} from "../App";
import CollectorList from "../Components/CollectorList";

class Collectors extends Component {

  constructor(props) {
    super(props);
    this.getCollectors = this.getCollectors.bind(this);
    this.addCollectorToList = this.addCollectorToList.bind(this);

    this.state = {
      collectors: [],
      loaded: false
    };

    this.getCollectors();

  }


  addCollectorToList(doc) {
    var collectorList = this.state.collectors;
    collectorList.push(doc.data());
    this.setState({collectors: collectorList})

    // console.log(collectorList.length);
    // console.log(this.state.collectors.length);
  }

  getCollectors() {

    // console.log("get collectors");

    firestoredb.collection("users")
      .limit(10)
      .get()
      .then((collectorList) => {
        // console.log(collectorList);
        collectorList.forEach((doc) => {
          // console.log(doc.id, " => ", doc.data());
          this.addCollectorToList(doc);
        });
       this.setState({loaded: true})
        // console.log(".then - done");
      })
      .catch(function(error) {
        // console.log("Error getting documents: ", error);
        this.setState({loaded: true})
      });
      // console.log("get collectors - done");
  }

  componentWillUpdate() {
    // console.log('component about to update!');
  }


  render() {
    if (this.state.loaded === false) {
      return (
        <Grid>
          <Row>
            <PageHeader>Collectors</PageHeader>
          </Row>
          <Row>
            <div>
              <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            </div>
          </Row>
        </Grid>
      )
    }

    return (
        <Grid>
          <Row>
            <PageHeader>Collectors</PageHeader>
          </Row>
          <Row>
            Collectors Page {this.state.collectors.length}
          </Row>
          <Row>
            <CollectorList collectors={this.state.collectors}/>
          </Row>
        </Grid>
    );
  }
}
export default Collectors;



// WEBPACK FOOTER //
// ./src/pages/Collectors.jsx